import React from 'react';
import { Checked } from '../../../assets/images';
import './Checkbox.scss';

type AppProps = {
  checked?: boolean;
  onPress?: () => void;
  disabled?: boolean;
}

const Checkbox = ({ checked, onPress, disabled }: AppProps) => {
  return (
    <div
      className={`checkboxContainer d-flex justify-content-center align-item-center pointer ${ disabled ? 'checkbox-disabled' : '' }`}
      onClick={disabled ? () => { } : onPress}
    >
      {checked &&
        <img src={Checked} alt="Checkbox Checked" />
      }
    </div>
  )
};

export default Checkbox;